"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
// Props should be kept for ts integration
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function MenuItem(props) {
    return null;
}
exports.MenuItem = MenuItem;
MenuItem.displayName = '@mantine/core/MenuItem';
